module.exports = __webpack_public_path__ + "img/pdf-logo.7033a675.png";